// extracted by mini-css-extract-plugin
export default {"label_wrapper":"Label_label_wrapper__8Mcrv","warning":"Label_warning__kzqkH"};